import type { I18nFn } from '#/i18n/types/I18nFn';

export function PAYMENT_TYPES(i18n: I18nFn) {
  return [
    {
      id: 'CHECK',
      name: i18n('Check'),
    },
    {
      id: 'EFT',
      name: i18n('EFT'),
    },
    {
      id: 'STRIPE',
      name: i18n('Credit Card'),
    },
    {
      id: 'LEGACY_CARD',
      name: i18n('Credit Card'),
    },
    {
      id: 'CREDIT',
      name: i18n('Job/Internship Credit'),
    },
    {
      id: 'PROMO_CREDIT',
      name: 'Promo Credit',
    },
    {
      id: 'VOID',
      name: i18n('Void'),
    },
    {
      id: 'LEGACY_BUG',
      name: i18n('Unknown'),
    },
  ] as const satisfies { id: string; name: string }[];
}

export type ApiPaymentType = ReturnType<typeof PAYMENT_TYPES>[number]['id'];
